import { render, staticRenderFns } from "./SalepointFormDialog.vue?vue&type=template&id=70ce03ae&scoped=true"
import script from "./SalepointFormDialog.vue?vue&type=script&lang=js"
export * from "./SalepointFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce03ae",
  null
  
)

export default component.exports